import React from "react";
import "./Spinner.css";

export default function Spinner(props) {
  if (props?.button) return <div className="Spinner-button" />;
  return <div className={props?.inline ? "Spinner-inline" : "Spinner"} />;
}
